import React from "react";
import { FolderOpen } from "lucide-react";

export function EmptyState({ title, hint, testid }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center" data-testid={testid || "empty-state"}>
      <FolderOpen className="w-12 h-12 text-slate-300 mb-3" />
      <div className="font-head text-lg font-semibold text-slate-700">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}

export function NoProject() {
  return <EmptyState title="No project selected" hint="Create or select a project to get started." testid="no-project" />;
}
